import {DataTable} from '../ui/DataTable';
import {Link} from '../ui/ScopedLink';
import {StatusBadge} from '../ui/StatusBadge';
import {formatDateTime} from '../dates';
import type {Batch} from './DocumentIngestion';

export function DocumentUploadHistory({rows,nextStep,history=false}:{rows:Batch[];nextStep:(row:Batch)=>string;history?:boolean}){
 return <DataTable caption={<span className="sr-only">{history?'Completed uploads and archived attempts':'Uploads needing attention'}</span>}
  scrollLabel={history?'Upload history':'Uploads needing attention'} rows={rows} getRowKey={row=>row.id} pageSize={18}
  rowHeader={{id:'upload',header:'Upload',render:row=><><Link to={'/documents/ingestion/'+row.id}>{row.source_name}</Link><span className="register-secondary">{row.batch_number}</span></>}}
  columns={[
   {id:'date',header:'Uploaded',render:row=>formatDateTime(row.created_at)},
   {id:'files',header:'Files',align:'right',render:row=>row.file_count},
   {id:'state',header:'Recorded state',render:row=><StatusBadge text={row.dismissed_at?'Archived attempt':history?'Complete':row.status}/>},
   {id:'next',header:history?'Retained note':'Next step',render:row=>history?row.dismissal_reason||'Originals and decisions retained':nextStep(row)},
  ]}/>;
}
